/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IRadiationTechnique } from 'app/shared/model/radiation-technique.model';
import { IRadiationBeamParameter } from 'app/shared/model/radiation-beam-parameter.model';
import { IRadiationDosimetry } from 'app/shared/model/radiation-dosimetry.model';

export interface IRadiationType {
  id?: string;
  name?: string | null;
  description?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  modality?: IClinicalDictionary | null;
  acquisitionParameters?: IClinicalDictionary | null;
  energy?: IClinicalDictionary | null;
  beamModality?: IClinicalDictionary | null;
  technique?: IRadiationTechnique | null;
  beamParams?: IRadiationBeamParameter[] | null;
  dosimetries?: IRadiationDosimetry[] | null;
}

export const defaultValue: Readonly<IRadiationType> = {
  active: false,
};
